import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import InputBox from './InputBox';
function Cards() {
  return (
    <div className='cards'>
      <h1>COLLEGE ADMISSIONS AND ACCEPTANCE CALCULATOR</h1>
      <div className='cards__container'>
        <InputBox/>
      </div>
    </div>
  );
}

export default Cards;
